import getMisc from "./miscService";

// Shared by MiscComponent and the route loaders of the pages it renders, so
// both land on one cache entry.
export const miscPageQuery = (pageName) => ({
  queryKey: ["miscPage", pageName],
  queryFn: () => getMisc(pageName),
});
